import * as React from 'react';
import { Modal, IconButton, Stack, Text, getTheme, mergeStyleSets } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const theme = getTheme();
export const ModalContent = _ref => {
  let {
    title,
    isOpen,
    accentColor = theme.palette.themePrimary,
    children,
    onDismiss
  } = _ref;
  const contentStyles = mergeStyleSets({
    container: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch'
    }
  });
  const headerContainerStyles = {
    root: {
      borderTop: "4px solid ".concat(accentColor)
    }
  };
  const headerTextStyles = {
    root: {
      color: theme.palette.neutralPrimary,
      padding: '12px 0 12px 12px'
    }
  };
  const bodyStyles = {
    root: {
      padding: '0 12px 12px 12px'
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onDismiss: onDismiss,
    isBlocking: false,
    containerClassName: contentStyles.container,
    children: [/*#__PURE__*/_jsxs(Stack, {
      styles: headerContainerStyles,
      horizontal: true,
      grow: true,
      children: [/*#__PURE__*/_jsx(Stack, {
        styles: headerTextStyles,
        grow: true,
        children: /*#__PURE__*/_jsx(Text, {
          variant: "large",
          children: title
        })
      }), /*#__PURE__*/_jsx(Stack, {
        horizontalAlign: "end",
        grow: true,
        children: /*#__PURE__*/_jsx(IconButton, {
          iconProps: {
            iconName: 'Cancel'
          },
          ariaLabel: "Close",
          onClick: onDismiss
        })
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      styles: bodyStyles,
      children: children
    })]
  });
};